import { ContractTypeApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { normalizeContractTypes } from './normalizers';
import { ContractType } from './types';

export class VoladeumContractTypes extends Axios {
  async list(): Promise<VoladeumResponse<ContractType[]>> {
    const res = await this.get<VoladeumResponse<ContractTypeApi[]>>('/v1/lookups/contract-types');
    return {
      success: res.success,
      error: res.error,
      data: normalizeContractTypes(res.data),
    };
  }
}
